import React, { useState, useRef, useEffect } from "react";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import Biometric from "../../../ResuableCompoment/Biometric";

const PpiTransfer = () => {
    const [showOtpFields, setShowOtpFields] = useState(false);
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [step, setStep] = useState(1);
    const [showPopup, setShowPopup] = useState(false);
    const [showOtpVerificationPopup, setShowOtpVerificationPopup] = useState(false);
    const [otpVerificationStatus, setOtpVerificationStatus] = useState({ success: false, message: "" });
    const [mobileNumber, setMobileNumber] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [error, setError] = useState('');
    const [mobileValidation, setMobileValidation] = useState({
        isValid: false,
        isTouched: false,
        errorMessage: ""
    });
    const [otpToken, setOtpToken] = useState("");
    const [isAadharVerified, setIsAadharVerified] = useState(false);
    const [remitterName, setRemitterName] = useState("");
    const [amountLimit, setAmountLimit] = useState("");
    const otpInputs = useRef([]);
    const reduxToken = useSelector((state) => state.auth.employeeDetails?.token);
    const merchantId = useSelector((state) => state.auth.employeeDetails?.username);
    const merchantAccountNo = useSelector((state) => state.auth.employeeDetails?.merchant_account_no);
    const [midError, setMidError] = useState('');
    const navigate = useNavigate();
    const [pidData, setPidData] = useState("");
    const [showConsentPopup, setShowConsentPopup] = useState(false);
    const [consentLanguages, setConsentLanguages] = useState([]);
    const [selectedConsentLang, setSelectedConsentLang] = useState("");
    const [consentText, setConsentText] = useState("");
    const [consentToken, setConsentToken] = useState("");
    const [consentAccepted, setConsentAccepted] = useState(false);
    const [verificationResponse, setVerificationResponse] = useState(null);
    const [userLocation, setUserLocation] = useState({ lat: "", lng: "" });
    const [aadhaarNumber, setAadhaarNumber] = useState("");
    const [panNumber, setPanNumber] = useState("");
    const [isPanVerified, setIsPanVerified] = useState(false);
    const [showPanVerificationPopup, setShowPanVerificationPopup] = useState(false);
    const [panVerificationStatus, setPanVerificationStatus] = useState({ success: false, message: "" });
    const [consentTextsMap, setConsentTextsMap] = useState({});
    const [showOtpMessagePopup, setShowOtpMessagePopup] = useState(false);
    const [otpMessage, setOtpMessage] = useState("");

    const { callApi: otpgenerate } = useApi("/ppi/otp/generate", "POST");
    const { callApi: otpverify } = useApi("/ppi/otp/verify", "POST");
    const { callApi: getConsent } = useApi("/ppi/get/consent", "GET");
    const { callApi: validateConsentApi } = useApi("/ppi/validate/consent", "POST");
    const { callApi: fetchConsentText } = useApi("/ppi/validate/consent", "POST");
    const { callApi: ekycApi } = useApi("/ppi/ekyc", "POST");
    const { callApi: verifyPanApi } = useApi("/ppi/verify/pan", "POST");

    const validateMobileNumber = (value) => {
        if (!value) {
            return {
                isValid: false,
                errorMessage: "Mobile number is required"
            };
        }

        if (value.length < 10) {
            return {
                isValid: false,
                errorMessage: "Mobile number must be 10 digits"
            };
        }

        if (!/^[6-9]\d{9}$/.test(value)) {
            return {
                isValid: false,
                errorMessage: "Mobile number should start with 6, 7, 8, or 9 and be 10 digits"
            };
        }

        return {
            isValid: true,
            errorMessage: ""
        };
    };

    useEffect(() => {
        if (!merchantId) {
            setMidError('Merchant ID not found. Please sign in again.');
            console.error('Merchant ID (username) is missing from auth state');
        } else {
            setMidError('');
        }
    }, [merchantId]);

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setUserLocation({
                        lat: position.coords.latitude.toString(),
                        lng: position.coords.longitude.toString()
                    });
                },
                (error) => {
                    console.error("Error getting location:", error);
                    setUserLocation({ lat: "28.4149837", lng: "77.0877049" });
                }
            );
        } else {
            setUserLocation({ lat: "28.4149837", lng: "77.0877049" });
        }
    }, []);

    // const generateOtp = async () => {
    //     if (!merchantId) {
    //         setErrorMessage("Authentication error: Merchant ID not available. Please sign in again.");
    //         return false;
    //     }

    //     const mobileValidationResult = validateMobileNumber(mobileNumber);
    //     if (!mobileValidationResult.isValid) {
    //         setMobileValidation({
    //             ...mobileValidationResult,
    //             isTouched: true
    //         });
    //         setErrorMessage(mobileValidationResult.errorMessage);
    //         return false;
    //     }

    //     setIsLoading(true);
    //     setErrorMessage("");

    //     try {
    //         const bodyrequest = {
    //             mobile_number: mobileNumber,
    //             mid: merchantId
    //         }
    //         const response = await otpgenerate(bodyrequest);

    //         console.log("OTP Generate response:", response);

    //         setIsLoading(false);

    //         if (response.status === "Success") {
    //             setOtpToken(response.otp_token || "");

    //             if (response.adhar_verified === true) {
    //                 console.log("User already Aadhaar verified");
    //                 setIsAadharVerified(true);

    //                 if (response.customer_name) {
    //                     setRemitterName(response.customer_name);
    //                 }
    //             } else {
    //                 setIsAadharVerified(false);
    //                 setRemitterName("");
    //             }

    //             setVerificationResponse(response);

    //             if (response.amount_limit) {
    //                 setAmountLimit(`₹${response.amount_limit}`);
    //             }

    //             setShowOtpFields(true);
    //             return true;
    //         } else {
    //             setErrorMessage("Failed to generate OTP. Please try again.");
    //             return false;
    //         }
    //     } catch (error) {
    //         setIsLoading(false);
    //         setErrorMessage(
    //             error.response?.data?.message ||
    //             "Failed to connect to the server."
    //         );
    //         console.error("OTP generation error:", error);
    //         return false;
    //     }
    // };

    const generateOtp = async () => {
        if (!merchantId) {
            setErrorMessage("Authentication error: Merchant ID not available. Please sign in again.");
            return false;
        }

        const mobileValidationResult = validateMobileNumber(mobileNumber);
        if (!mobileValidationResult.isValid) {
            setMobileValidation({
                ...mobileValidationResult,
                isTouched: true
            });
            setErrorMessage(mobileValidationResult.errorMessage);
            return false;
        }

        setIsLoading(true);
        setErrorMessage("");

        try {
            const bodyrequest = {
                mobile_number: mobileNumber,
                mid: merchantId
            }
            const response = await otpgenerate(bodyrequest);

            console.log("OTP Generate response:", response);

            setIsLoading(false);

            // Set the message from API response and show popup
            if (response.message) {
                setOtpMessage(response.message);
                setShowOtpMessagePopup(true);
            }

            if (response.status === "Success") {
                setOtpToken(response.otp_token || "");

                if (response.adhar_verified === true) {
                    console.log("User already Aadhaar verified");
                    setIsAadharVerified(true);

                    if (response.customer_name) {
                        setRemitterName(response.customer_name);
                    }
                } else {
                    setIsAadharVerified(false);
                    setRemitterName("");
                }

                setVerificationResponse(response);

                if (response.amount_limit) {
                    setAmountLimit(`₹${response.amount_limit}`);
                }

                setShowOtpFields(true);
                return true;
            } else {
                setErrorMessage("Failed to generate OTP. Please try again.");
                return false;
            }
        } catch (error) {
            setIsLoading(false);
            setErrorMessage(
                error.response?.data?.message ||
                "Failed to connect to the server."
            );
            console.error("OTP generation error:", error);
            return false;
        }
    };

    // Add a handler to close the OTP message popup
    const handleCloseOtpMessagePopup = () => {
        setShowOtpMessagePopup(false);
    };

    const verifyOtp = async () => {
        if (otp.join("").length !== 6) {
            setErrorMessage("Please enter the complete OTP");
            return false;
        }

        if (!otpToken) {
            setErrorMessage("OTP session expired. Please request a new OTP");
            return false;
        }
        if (!merchantId) {
            setError("Merchant ID not available. Please log in again.");
            return;
        }

        if (!merchantAccountNo) {
            setErrorMessage("Merchant account number not available. Please log in again.");
            return;
        }

        setIsLoading(true);
        setErrorMessage("");

        try {
            const bodyrequest = {
                otp_token: otpToken,
                otp: otp.join("")
            }
            const response = await otpverify(bodyrequest, `?mobile_number=${mobileNumber}&userName=${merchantId}&merchant_account_no=${merchantAccountNo}`);

            setIsLoading(false);
            setVerificationResponse(response);

            console.log("OTP Verify response:", response);
            console.log("Token in response:", response.token);

            if (response.otp_status === "Success") {
                console.log("OTP verified successfully. Setting consent token:", response.token);

                setConsentToken(response.token);
                localStorage.setItem('ppi_auth_token', response.token);

                const aadharVerified = response.adhar_verified === true;
                const panVerified = response.pan_verified === true;

                setIsAadharVerified(aadharVerified);
                setIsPanVerified(panVerified);

                if (aadharVerified && response.customer_name) {
                    setRemitterName(response.customer_name);
                    console.log("Setting remitter name to:", response.customer_name);
                }

                if (response.amount_limit) {
                    setAmountLimit(`₹${response.amount_limit}`);
                }

                if (response.token) {
                    setConsentToken(response.token);
                }

                setOtpVerificationStatus({
                    success: true,
                    message: "OTP verified successfully!"
                });
                setShowOtpVerificationPopup(true);
                return true;
            } else {
                setOtpVerificationStatus({
                    success: false,
                    message: "OTP verification failed. Please check the OTP and try again."
                });
                setShowOtpVerificationPopup(true);
                return false;
            }
        } catch (error) {
            setIsLoading(false);
            const errorMsg = error.response?.data?.message ||
                "Failed to verify OTP. Please try again.";
            setOtpVerificationStatus({
                success: false,
                message: errorMsg
            });
            setShowOtpVerificationPopup(true);
            console.error("OTP verification error:", error);
            return false;
        }
    };

    const determineNextStep = () => {
        console.log("Determining next step. Aadhaar verified:", isAadharVerified, "PAN verified:", isPanVerified);

        if (isAadharVerified && isPanVerified) {
            console.log("Both Aadhaar and PAN are verified. Navigating to remitter page.");
            navigateToRemitterPage();
            return;
        }
        if (!isAadharVerified) {
            console.log("Aadhaar not verified. Going to biometric verification step.");

            fetchConsentDetails().then(success => {
                console.log("Consent details fetch result:", success);
                if (success && !showConsentPopup) {
                    console.log("Forcing consent popup visibility");
                    setShowConsentPopup(true);
                }
            });
            return;
        }

        if (!isPanVerified) {
            console.log("PAN not verified. Going to PAN verification step.");
            setStep(3);
            return;
        }
    };

    const logResponseStructure = (data) => {
        console.log("Response structure analysis:");
        console.log("- Type:", typeof data);

        if (Array.isArray(data)) {
            console.log("- Is Array: true, Length:", data.length);
            if (data.length > 0) {
                console.log("- First item keys:", Object.keys(data[0]));
                console.log("- First item sample:", data[0]);
            }
        } else if (typeof data === 'object' && data !== null) {
            console.log("- Is Object: true");
            console.log("- Object keys:", Object.keys(data));

            const hasCons = 'consent' in data;
            const hasContent = 'consent_content' in data;
            const hasText = 'consent_text' in data;
            console.log(`- Has consent: ${hasCons}, content: ${hasContent}, text: ${hasText}`);

            if (hasCons) console.log("- Consent value:", data.consent);
            if (hasContent) console.log("- Content value:", data.consent_content);
            if (hasText) console.log("- Text value:", data.consent_text);
        }
    };

    const fetchConsentDetails = async () => {
        if (!consentToken) {
            console.error("No consent token available");
            setErrorMessage("Authentication token missing. Please try again.");
            return false;
        }

        setIsLoading(true);
        setErrorMessage("");

        try {
            console.log("Fetching consent details with token:", consentToken);

            const response = await getConsent(null, `?token=${consentToken}`);

            console.log("Consent API response:", response);

            setIsLoading(false);

            let consentData;

            if (response && response.data) {
                consentData = response.data;
            } else {
                consentData = response;
            }

            if (Array.isArray(consentData) && consentData.length > 0) {
                setConsentLanguages(consentData);

                const defaultLang = consentData[0];
                const langCode = defaultLang.language_code || defaultLang.id || "1";
                setSelectedConsentLang(langCode);

                await fetchConsentTextForLanguage(langCode);

                setShowConsentPopup(true);
                return true;
            } else if (typeof consentData === 'object' && consentData !== null) {
                const possibleArrays = Object.values(consentData).filter(val => Array.isArray(val));

                if (possibleArrays.length > 0 && possibleArrays[0].length > 0) {
                    setConsentLanguages(possibleArrays[0]);

                    const defaultLang = possibleArrays[0][0];
                    const langCode = defaultLang.language_code || defaultLang.id || "1";
                    setSelectedConsentLang(langCode);

                    await fetchConsentTextForLanguage(langCode);
                    setShowConsentPopup(true);
                    return true;
                } else {
                    console.warn("No language array found in response, using fallback");
                    setConsentLanguages([{
                        id: "1",
                        language_code: "1",
                        language_name: "English"
                    }]);
                    setSelectedConsentLang("1");
                    await fetchConsentTextForLanguage("1");
                    setShowConsentPopup(true);
                    return true;
                }
            } else {
                console.warn("Response doesn't contain valid languages data, using fallback");
                setConsentLanguages([{
                    id: "1",
                    language_code: "1",
                    language_name: "English"
                }]);
                setSelectedConsentLang("1");
                await fetchConsentTextForLanguage("1");
                setShowConsentPopup(true);
                return true;
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Consent fetch error:", error);

            const errorMsg = error.response?.data?.message ||
                error.response?.data?.error ||
                "Failed to connect to the server. Please try again.";

            setErrorMessage(errorMsg);
            return false;
        }
    };

    const fetchConsentTextForLanguage = async (langCode) => {
        if (!consentToken || !langCode) {
            return;
        }

        try {
            console.log(`Fetching consent text for language: ${langCode}`);

            const bodyRequest = { consentlang_id: langCode };
            const response = await fetchConsentText(bodyRequest, `?token=${consentToken}&preview=true`);

            console.log(`Consent text response for ${langCode}:`, response);

            const responseData = response.data || response;

            if (responseData) {
                let extractedText = "";

                if (responseData.consent_content) {
                    extractedText = responseData.consent_content;
                } else if (responseData.consent) {
                    extractedText = responseData.consent;
                } else if (responseData.consent_text) {
                    extractedText = responseData.consent_text;
                } else if (typeof responseData === 'string') {
                    extractedText = responseData;
                } else {
                    const textProperties = Object.entries(responseData)
                        .filter(([key, value]) =>
                            typeof value === 'string' &&
                            key.toLowerCase().includes('consent')
                        );

                    if (textProperties.length > 0) {
                        extractedText = textProperties[0][1];
                    } else {
                        console.warn("Could not find consent text in response");
                        extractedText = "Please agree to the consent terms to proceed.";
                    }
                }

                setConsentText(extractedText);

                setConsentTextsMap(prev => ({
                    ...prev,
                    [langCode]: extractedText
                }));
            }
        } catch (error) {
            console.error(`Error fetching consent text for language ${langCode}:`, error);
            setConsentText("Please agree to the consent terms to proceed.");
        }
    };

    // Update the fetchConsentTextForLanguage function to use htmlDecode
    // const fetchConsentTextForLanguage = async (langCode) => {
    //     if (!consentToken || !langCode) {
    //         return;
    //     }

    //     try {
    //         console.log(`Fetching consent text for language: ${langCode}`);

    //         const bodyRequest = { consentlang_id: langCode };
    //         const response = await fetchConsentText(bodyRequest, `?token=${consentToken}&preview=true`);

    //         console.log(`Consent text response for ${langCode}:`, response);

    //         const responseData = response.data || response;

    //         if (responseData) {
    //             let extractedText = "";

    //             if (responseData.consent_content) {
    //                 extractedText = responseData.consent_content;
    //             } else if (responseData.consent) {
    //                 extractedText = responseData.consent;
    //             } else if (responseData.consent_text) {
    //                 extractedText = responseData.consent_text;
    //             } else if (typeof responseData === 'string') {
    //                 extractedText = responseData;
    //             } else {
    //                 const textProperties = Object.entries(responseData)
    //                     .filter(([key, value]) =>
    //                         typeof value === 'string' &&
    //                         key.toLowerCase().includes('consent')
    //                     );

    //                 if (textProperties.length > 0) {
    //                     extractedText = textProperties[0][1];
    //                 } else {
    //                     console.warn("Could not find consent text in response");
    //                     extractedText = "Please agree to the consent terms to proceed.";
    //                 }
    //             }

    //             const decodedText = htmlDecode(extractedText);

    //             setConsentText(decodedText);

    //             setConsentTextsMap(prev => ({
    //                 ...prev,
    //                 [langCode]: decodedText
    //             }));
    //         }
    //     } catch (error) {
    //         console.error(`Error fetching consent text for language ${langCode}:`, error);
    //         setConsentText("Please agree to the consent terms to proceed.");
    //     }
    // };

    // const htmlDecode = (input) => {
    //     const parser = new DOMParser();
    //     const decodedString = parser.parseFromString(input, "text/html").documentElement.textContent || "";
    //     return decodedString;
    // };

    const validateConsent = async () => {
        if (!selectedConsentLang) {
            setErrorMessage("Please select a language for consent");
            return false;
        }

        if (!consentToken) {
            setErrorMessage("Consent token is missing. Please try again.");
            return false;
        }

        setIsLoading(true);
        setErrorMessage("");

        try {
            console.log("Validating consent with language:", selectedConsentLang);

            const bodyRequest = { consentlang_id: selectedConsentLang };

            const response = await validateConsentApi(bodyRequest, `?token=${consentToken}`);
            console.log("API Response:", response);

            setIsLoading(false);

            const responseType = typeof response;
            console.log("Response type:", responseType);

            if (responseType === 'object' && response !== null) {
                console.log("Response keys:", Object.keys(response));
                if (response.data) {
                    console.log("Response.data keys:", Object.keys(response.data));
                }
            }

            console.log("Consent validation successful (assuming 200 status from API)");

            setConsentAccepted(true);
            setShowConsentPopup(false);
            setStep(2);
            return true;
        } catch (error) {
            setIsLoading(false);
            console.error("Consent validation error:", error);

            const errorMsg = error.response?.data?.message ||
                error.response?.data?.error ||
                "Failed to connect to the server. Please try again.";

            setErrorMessage(errorMsg);
            return false;
        }
    };

    const renderDebugInfo = () => {
        return (
            <div className="mt-2 p-2 bg-gray-100 rounded-md text-xs text-gray-600">
                <p><strong>Selected Language:</strong> {selectedConsentLang}</p>
                <p><strong>Consent Text Length:</strong> {consentText ? consentText.length : 0} chars</p>
                <p><strong>Available Languages:</strong> {consentLanguages.length}</p>
            </div>
        );
    };

    const handleProceed = async () => {
        if (step === 1 && !showOtpFields) {
            const otpGenerated = await generateOtp();
            if (!otpGenerated) return;
        } else if (step === 1 && showOtpFields) {
            const otpVerified = await verifyOtp();
            if (!otpVerified) return;
        } else if (step === 2) {
            if (!isAadharVerified) {
                setErrorMessage("Please complete the biometric verification first.");
                return;
            }
            setShowPopup(true);
        } else if (step === 3) {
            const panVerified = await verifyPan();
            if (panVerified) {
                navigateToRemitterPage();
            }
        }
    };

    const navigateToRemitterPage = () => {
        if (!isAadharVerified) {
            setErrorMessage("Aadhaar verification is required before proceeding.");
            return;
        }

        if (!isPanVerified) {
            setErrorMessage("PAN verification is required before proceeding.");
            return;
        }
        console.log("Navigating to RemitterPage with data:", {
            name: remitterName,
            mobileNumber: mobileNumber,
            amountLimit: amountLimit,
            isVerified: isAadharVerified,
            token: consentToken
        });

        navigate("/ppi-remitterpage", {
            state: {
                remitterDetails: {
                    name: remitterName,
                    mobileNumber: mobileNumber,
                    amountLimit: amountLimit,
                    isVerified: isAadharVerified,
                    isPanVerified: isPanVerified,
                    token: consentToken
                }
            }
        });
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        if (isPanVerified) {
            navigateToRemitterPage();
        } else {
            setStep(3);
        }
    };

    const handleCloseOtpVerificationPopup = () => {
        setShowOtpVerificationPopup(false);
        if (otpVerificationStatus.success) {
            setOtp(["", "", "", "", "", ""]);
            setOtpToken("");
            setShowOtpFields(false);
            setErrorMessage("");
            determineNextStep();
        }
    };

    const handleOtpChange = (index, value) => {
        if (value.length > 1) return;
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < otp.length - 1) {
            otpInputs.current[index + 1].focus();
        }

        if (value && index === otp.length - 1) {
            const isComplete = newOtp.every(digit => digit !== "");
            if (isComplete) {
                setTimeout(() => {
                    handleProceed();
                }, 8000);
            }
        }
    };


    const handleOtpKeyDown = (index, e) => {
        if (e.key === "Backspace") {
            const newOtp = [...otp];
            newOtp[index] = "";
            setOtp(newOtp);

            if (!otp[index] && index > 0) {
                otpInputs.current[index - 1].focus();
            }
        }
    };

    const handleMobileNumberChange = (e) => {
        const value = e.target.value.replace(/\D/g, "").slice(0, 10);
        setMobileNumber(value);

        if (mobileValidation.isTouched) {
            const validation = validateMobileNumber(value);
            setMobileValidation({
                ...validation,
                isTouched: true
            });
        }

        if (errorMessage) setErrorMessage("");
    };

    const handleMobileNumberBlur = () => {
        const validation = validateMobileNumber(mobileNumber);
        setMobileValidation({
            ...validation,
            isTouched: true
        });
    };

    const handleAadhaarNumberChange = (e) => {
        const value = e.target.value.replace(/\D/g, "").slice(0, 12);
        setAadhaarNumber(value);
        if (errorMessage) setErrorMessage("");
    };

    const handlePanNumberChange = (e) => {
        const value = e.target.value.toUpperCase().slice(0, 10);
        setPanNumber(value);
        if (errorMessage) setErrorMessage("");
    };

    const handleResendOtp = async () => {
        setOtp(["", "", "", "", "", ""]);
        setOtpToken("");
        await generateOtp();
    };

    const handleConsentLanguageChange = async (e) => {
        const langCode = e.target.value;
        setSelectedConsentLang(langCode);

        if (consentTextsMap && consentTextsMap[langCode]) {
            console.log(`Using cached consent text for language ${langCode}`);
            setConsentText(consentTextsMap[langCode]);
            return;
        }

        await fetchConsentTextForLanguage(langCode);
    };

    const handleBiometricVerification = (response) => {
        if (response?.customer_name) {
            setRemitterName(response.customer_name);
            setIsAadharVerified(true);
        }

        if (response?.amount_limit) {
            setAmountLimit(`₹${response.amount_limit}`);
        }
    };

    const performEkyc = async () => {
        if (!merchantId) {
            setErrorMessage("Authentication error: Merchant ID not available. Please sign in again.");
            return;
        }

        if (!aadhaarNumber || aadhaarNumber.length !== 12) {
            setErrorMessage("Please enter a valid 12-digit Aadhaar Number");
            return;
        }

        if (!pidData) {
            setErrorMessage("Biometric data is required. Please scan your fingerprint.");
            return;
        }

        console.log("Current state before eKYC call:", {
            consentAccepted,
            mobileNumber,
            aadhaarNumber,
            userLocation,
            consentToken,
            token: consentToken || (verificationResponse?.token || "")
        });

        setIsLoading(true);
        setErrorMessage("");

        try {
            const payload = {
                mid: merchantId,
                mobile: mobileNumber,
                adhaar: aadhaarNumber,
                lat: userLocation.lat,
                lng: userLocation.lng,
                consent: consentAccepted ? "1" : "0",
                consent_taken: consentAccepted,
                biometric_code: pidData,
                token: consentToken || (verificationResponse?.token || "")
            };

            console.log("eKYC Payload:", payload);
            const response = await ekycApi(payload);

            console.log("eKYC Full Response:", response);
            console.log("eKYC Response Data:", response.data);
            console.log("Response status:", response.status);
            console.log("Response data status:", response.data?.status);
            console.log("Response data status:", response.data?.adhaarVerified);
            setIsLoading(false);


            const isSuccess =
                response && (
                    response.status === "Success" ||
                    response.status === "SUCCESS" ||
                    response.status === true ||
                    response.status === "true" ||
                    response.status === 200 ||
                    response.statusCode === 200 ||
                    response.status === 200 ||
                    response.adhaarVerified === true
                );

            if (isSuccess) {

                setErrorMessage("");
                setIsAadharVerified(true);
                setShowPopup(true);
            } else {
                const message = response.data?.message || response.data?.errorMessage || "Verification failed. Please try again.";
                setErrorMessage(message);
            }
        } catch (error) {
            setIsLoading(false);
            const errorMsg = error.response?.data?.message ||
                error.response?.data?.errorMessage ||
                "Failed to connect to the server.";
            setErrorMessage(errorMsg);
            console.error("eKYC Error:", error);
        }
    };

    const verifyPan = async () => {
        if (!merchantId) {
            setErrorMessage("Authentication error: Merchant ID not available. Please sign in again.");
            return false;
        }

        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!panNumber || !panRegex.test(panNumber)) {
            setErrorMessage("Please enter a valid 10-character PAN number");
            return false;
        }

        setIsLoading(true);
        setErrorMessage("");

        try {
            const payload = {
                pan: panNumber,
                remitter_mobile: mobileNumber,
                mid: merchantId,
                token: consentToken || (verificationResponse?.token || "")
            };

            console.log("PAN Verification Payload:", payload);
            const response = await verifyPanApi(payload);

            console.log("PAN Verification Raw Response:", response);

            console.log("PAN Verification Response Type:", typeof response);
            if (response !== null && response !== undefined) {
                if (typeof response === 'object') {
                    console.log("Response keys:", Object.keys(response || {}));
                }
            } else {
                console.log("Response is null or undefined");
            }

            setIsLoading(false);

            if (!response) {
                console.log("Response is null or undefined - treating as failure");
                const message = "Unable to verify PAN. Please try again.";
                setErrorMessage(message);
                setPanVerificationStatus({
                    success: false,
                    message: message
                });
                setShowPanVerificationPopup(true);
                return false;
            }

            if (response.pan_status === true) {
                console.log("PAN verification successful based on pan_status");
                setIsPanVerified(true);
                setErrorMessage("");
                setPanVerificationStatus({
                    success: true,
                    message: "PAN verification successful!"
                });
                setShowPanVerificationPopup(true);
                return true;
            }

            if (response.data && (
                response.data.status === "Success" ||
                response.data.status === "SUCCESS" ||
                response.data.status === true ||
                response.data.status === "true" ||
                response.data.status === 200 ||
                response.data.statusCode === 200
            )) {
                console.log("PAN verification successful based on standard status fields");
                setIsPanVerified(true);
                setErrorMessage("");
                setPanVerificationStatus({
                    success: true,
                    message: "PAN verification successful!"
                });
                setShowPanVerificationPopup(true);
                return true;
            }

            if (response.status === 200) {
                console.log("PAN verification successful based on top-level status field");
                setIsPanVerified(true);
                setErrorMessage("");
                setPanVerificationStatus({
                    success: true,
                    message: "PAN verification successful!"
                });
                setShowPanVerificationPopup(true);
                return true;
            }

            console.log("PAN verification failed - response didn't match success criteria");
            setIsPanVerified(false);

            let message = "PAN verification failed. Please check the details and try again.";

            if (typeof response === 'string') {
                console.log("Response is a string:", response);
                if (response.includes('resultMessage=')) {
                    const match = response.match(/resultMessage=([^,)]+)/);
                    if (match && match[1]) {
                        message = match[1].trim();
                        console.log("Extracted message from string:", message);
                    }
                }
            }
            else if (typeof response === 'object') {
                if (response.resultMessage) {
                    message = response.resultMessage;
                    console.log("Using resultMessage property:", message);
                } else if (response.message) {
                    message = response.message;
                    console.log("Using message property:", message);
                } else if (response.errorMessage) {
                    message = response.errorMessage;
                    console.log("Using errorMessage property:", message);
                } else if (response.error) {
                    message = typeof response.error === 'string' ? response.error : "Verification failed";
                    console.log("Using error property:", message);
                }

                else if (response.data) {
                    if (typeof response.data === 'string' && response.data.includes('resultMessage=')) {
                        const match = response.data.match(/resultMessage=([^,)]+)/);
                        if (match && match[1]) {
                            message = match[1].trim();
                            console.log("Extracted message from data string:", message);
                        }
                    } else if (typeof response.data === 'object' && response.data !== null) {
                        if (response.data.resultMessage) {
                            message = response.data.resultMessage;
                            console.log("Using data.resultMessage property:", message);
                        } else if (response.data.message) {
                            message = response.data.message;
                            console.log("Using data.message property:", message);
                        } else if (response.data.errorMessage) {
                            message = response.data.errorMessage;
                            console.log("Using data.errorMessage property:", message);
                        } else if (response.data.error) {
                            message = typeof response.data.error === 'string' ? response.data.error : "Verification failed";
                            console.log("Using data.error property:", message);
                        }
                    }
                }
            }

            console.log("Final extracted error message:", message);
            setErrorMessage(message);
            setPanVerificationStatus({
                success: false,
                message: message
            });
            setShowPanVerificationPopup(true);
            return false;
        } catch (error) {
            console.error("PAN Verification Error:", error);

            if (error) {
                if (error.response) {
                    console.error("Response status:", error.response.status);

                    if (error.response.data !== undefined && error.response.data !== null) {
                        console.error("Response data:", error.response.data);

                        if (typeof error.response.data === 'object') {
                            console.error("Response data keys:", Object.keys(error.response.data));
                        }
                    } else {
                        console.error("Response data is null or undefined");
                    }

                    if (error.response.headers) {
                        console.error("Response headers:", error.response.headers);
                    }
                } else {
                    console.error("Error message:", error.message || "Unknown error");
                }
            } else {
                console.error("Error is null or undefined");
            }
    
            setIsLoading(false);
            setIsPanVerified(false);
    
            let errorMsg = "Failed to connect to the server.";
            
            if (error && error.response) {
                if (error.response.data !== undefined && error.response.data !== null) {
                    if (typeof error.response.data === 'string') {
                        console.log("Error response data is string:", error.response.data);
                        
                        if (error.response.data.includes('resultMessage=')) {
                            const match = error.response.data.match(/resultMessage=([^,)]+)/);
                            if (match && match[1]) {
                                errorMsg = match[1].trim();
                                console.log("Extracted from string in catch block:", errorMsg);
                            }
                        } else {
                            if (error.response.data.length < 100) {
                                errorMsg = error.response.data;
                                console.log("Using entire response data string:", errorMsg);
                            }
                        }
                    } 
                    else if (typeof error.response.data === 'object') {
                        if (error.response.data.resultMessage) {
                            errorMsg = error.response.data.resultMessage;
                            console.log("Using error.response.data.resultMessage:", errorMsg);
                        } else if (error.response.data.message) {
                            errorMsg = error.response.data.message;
                            console.log("Using error.response.data.message:", errorMsg);
                        } else if (error.response.data.errorMessage) {
                            errorMsg = error.response.data.errorMessage;
                            console.log("Using error.response.data.errorMessage:", errorMsg);
                        } else if (error.response.data.error) {
                            errorMsg = typeof error.response.data.error === 'string' ? 
                                error.response.data.error : "Verification failed";
                            console.log("Using error.response.data.error:", errorMsg);
                        }
                        
                        if (errorMsg === "Failed to connect to the server.") {
                            for (const key in error.response.data) {
                                if (error.response.data[key] !== null && 
                                    typeof error.response.data[key] === 'string' && 
                                    (key.toLowerCase().includes('error') || key.toLowerCase().includes('message'))) {
                                    errorMsg = error.response.data[key];
                                    console.log(`Found error message in property ${key}:`, errorMsg);
                                    break;
                                }
                            }
                        }
                    }
                }
            } else if (error && error.message) {
                errorMsg = error.message;
                console.log("Using error.message:", errorMsg);
            }
    
            console.log("Final catch block error message:", errorMsg);
            setErrorMessage(errorMsg);
    
            setPanVerificationStatus({
                success: false,
                message: errorMsg
            });
    
            setShowPanVerificationPopup(true);
            return false;
        }
    };
    const handleClosePanVerificationPopup = () => {
        setShowPanVerificationPopup(false);

        if (panVerificationStatus.success && isAadharVerified) {
            navigateToRemitterPage();
        }
    };

    return (
        <div className="flex flex-col items-center bg-white min-h-screen">
            {midError && (
                <div className="mt-4 w-full max-w-sm bg-red-100 text-red-700 p-3 rounded-md">
                    {midError}
                </div>
            )}

            <h1 className="text-xl font-bold text-center text-gray-800 mt-10">
                Secure Your Future with Our PPI Service!
            </h1>
            <div className="bg-orange-50 p-2 rounded-md mt-4 mb-4 flex items-center">
                <span className="text-orange-500 mr-2">

                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.04167 3.64559V1.0416H3.64583C3.78397 1.0416 3.91644 0.986727 4.01412 0.889058C4.11179 0.79139 4.16667 0.658923 4.16667 0.520798C4.16667 0.382674 4.11179 0.250207 4.01412 0.152538C3.91644 0.0548697 3.78397 0 3.64583 0L0.520833 0C0.3827 0 0.250224 0.0548697 0.152549 0.152538C0.0548734 0.250207 0 0.382674 0 0.520798L0 3.64559C0 3.78371 0.0548734 3.91618 0.152549 4.01385C0.250224 4.11152 0.3827 4.16639 0.520833 4.16639C0.658967 4.16639 0.791443 4.11152 0.889118 4.01385C0.986793 3.91618 1.04167 3.78371 1.04167 3.64559Z" fill="#D45A23" />
                        <path d="M24.4792 0H21.3542C21.216 0 21.0836 0.0548697 20.9859 0.152538C20.8882 0.250207 20.8333 0.382674 20.8333 0.520798C20.8333 0.658923 20.8882 0.79139 20.9859 0.889058C21.0836 0.986727 21.216 1.0416 21.3542 1.0416H23.9583V3.64559C23.9583 3.78371 24.0132 3.91618 24.1109 4.01385C24.2086 4.11152 24.341 4.16639 24.4792 4.16639C24.6173 4.16639 24.7498 4.11152 24.8475 4.01385C24.9451 3.91618 25 3.78371 25 3.64559V0.520798C25 0.382674 24.9451 0.250207 24.8475 0.152538C24.7498 0.0548697 24.6173 0 24.4792 0Z" fill="#D45A23" />
                        <path d="M3.64583 23.9568H1.04167V21.3528C1.04167 21.2147 0.986793 21.0822 0.889118 20.9846C0.791443 20.8869 0.658967 20.832 0.520833 20.832C0.3827 20.832 0.250224 20.8869 0.152549 20.9846C0.0548734 21.0822 0 21.2147 0 21.3528L0 24.4776C0 24.6157 0.0548734 24.7482 0.152549 24.8459C0.250224 24.9435 0.3827 24.9984 0.520833 24.9984H3.64583C3.78397 24.9984 3.91644 24.9435 4.01412 24.8459C4.11179 24.7482 4.16667 24.6157 4.16667 24.4776C4.16667 24.3395 4.11179 24.207 4.01412 24.1094C3.91644 24.0117 3.78397 23.9568 3.64583 23.9568Z" fill="#D45A23" />
                        <path d="M23.9583 21.3528V23.9568H21.3541C21.216 23.9568 21.0835 24.0117 20.9858 24.1094C20.8882 24.207 20.8333 24.3395 20.8333 24.4776C20.8333 24.6157 20.8882 24.7482 20.9858 24.8459C21.0835 24.9435 21.216 24.9984 21.3541 24.9984H24.4791C24.6172 24.9984 24.7497 24.9435 24.8474 24.8459C24.9451 24.7482 24.9999 24.6157 24.9999 24.4776V21.3528C24.9999 21.2147 24.9451 21.0822 24.8474 20.9846C24.7497 20.8869 24.6172 20.832 24.4791 20.832C24.341 20.832 24.2085 20.8869 24.1108 20.9846C24.0132 21.0822 23.9583 21.2147 23.9583 21.3528Z" fill="#D45A23" />
                        <path d="M20.8334 19.268C19.9012 19.2675 18.9832 19.0395 18.1591 18.6039C17.335 18.1682 16.6296 17.5381 16.1042 16.7682C16.0254 16.6561 15.9056 16.5795 15.7708 16.5552C15.6359 16.5308 15.4969 16.5606 15.3839 16.638C15.2708 16.7154 15.1928 16.8343 15.1668 16.9688C15.1408 17.1033 15.1688 17.2427 15.2449 17.3567C15.8659 18.2663 16.6995 19.0107 17.6734 19.5252C18.6472 20.0398 19.7319 20.309 20.8334 20.3096C20.9715 20.3096 21.104 20.2547 21.2017 20.1571C21.2994 20.0594 21.3542 19.9269 21.3542 19.7888C21.3542 19.6507 21.2994 19.5182 21.2017 19.4205C21.104 19.3229 20.9715 19.268 20.8334 19.268Z" fill="#D45A23" />
                        <path d="M3.64581 11.8359C3.63259 12.1881 3.68987 12.5394 3.8143 12.8692C3.93873 13.1989 4.12778 13.5005 4.37038 13.7561C4.61297 14.0118 4.9042 14.2164 5.22698 14.358C5.54975 14.4996 5.89756 14.5752 6.24998 14.5805C6.94065 14.5805 7.60303 14.3062 8.0914 13.8179C8.57978 13.3295 8.85415 12.6672 8.85415 11.9766C8.85415 10.7214 8.73435 9.46631 10.0104 8.27368C10.5384 7.77913 11.2015 7.45281 11.9155 7.33626C12.6295 7.2197 13.362 7.31818 14.0198 7.61916C14.6777 7.92014 15.2311 8.41001 15.6097 9.02644C15.9883 9.64287 16.1749 10.358 16.1458 11.0808V13.539C16.1458 14.7821 16.6397 15.9743 17.5188 16.8533C18.3978 17.7323 19.5901 18.2261 20.8333 18.2261C20.9714 18.2261 21.1039 18.1713 21.2016 18.0736C21.2993 17.9759 21.3541 17.8435 21.3541 17.7053C21.3541 17.5672 21.2993 17.4347 21.2016 17.3371C21.1039 17.2394 20.9714 17.1845 20.8333 17.1845C19.8664 17.1845 18.939 16.8005 18.2553 16.1168C17.5716 15.4331 17.1875 14.5058 17.1875 13.539V11.0808C17.1875 6.88315 12.3177 4.68538 9.30206 7.51331C7.73956 8.98717 7.81248 10.6381 7.81248 11.9766C7.79383 12.3909 7.61133 12.7809 7.30512 13.0607C6.9989 13.3406 6.59407 13.4873 6.17967 13.4686C5.76527 13.45 5.37525 13.2675 5.09541 12.9613C4.81557 12.6551 4.66883 12.2503 4.68748 11.8359V11.1797C4.65105 9.14098 5.40125 7.16651 6.78232 5.66625C8.16338 4.16599 10.0692 3.25521 12.1041 3.12298C13.1629 3.06927 14.2215 3.23159 15.2156 3.60006C16.2096 3.96853 17.1182 4.53544 17.8861 5.26627C18.654 5.9971 19.2652 6.87656 19.6823 7.85111C20.0994 8.82566 20.3138 9.8749 20.3125 10.935V13.539C20.3125 13.6771 20.3674 13.8095 20.465 13.9072C20.5627 14.0049 20.6952 14.0598 20.8333 14.0598C20.9714 14.0598 21.1039 14.0049 21.2016 13.9072C21.2993 13.8095 21.3541 13.6771 21.3541 13.539V10.935C21.3556 9.73409 21.1128 8.54546 20.6404 7.44138C20.168 6.33731 19.476 5.34087 18.6063 4.51268C17.7367 3.68449 16.7076 3.04186 15.5817 2.62389C14.4559 2.20592 13.2567 2.02134 12.0573 2.08139C9.75429 2.22572 7.59541 3.25157 6.02903 4.94587C4.46265 6.64016 3.60915 8.87268 3.64581 11.1797V11.8359Z" fill="#D45A23" />
                        <path d="M20.8334 16.1424C20.9715 16.1424 21.104 16.0876 21.2017 15.9899C21.2993 15.8922 21.3542 15.7598 21.3542 15.6216C21.3542 15.4835 21.2993 15.351 21.2017 15.2534C21.104 15.1557 20.9715 15.1008 20.8334 15.1008C20.419 15.1008 20.0216 14.9362 19.7285 14.6432C19.4355 14.3502 19.2709 13.9528 19.2709 13.5384V10.9344C19.2709 9.13883 18.5575 7.41675 17.2878 6.14706C16.018 4.87737 14.2958 4.16406 12.5001 4.16406C10.7043 4.16406 8.98213 4.87737 7.71235 6.14706C6.44257 7.41675 5.72922 9.13883 5.72922 10.9344V11.976C5.72922 12.1142 5.78409 12.2466 5.88177 12.3443C5.97944 12.442 6.11192 12.4968 6.25005 12.4968C6.38818 12.4968 6.52066 12.442 6.61834 12.3443C6.71601 12.2466 6.77088 12.1142 6.77088 11.976V10.9344C6.77088 9.41507 7.37449 7.95794 8.44892 6.88358C9.52334 5.80923 10.9806 5.20566 12.5001 5.20566C14.0195 5.20566 15.4768 5.80923 16.5512 6.88358C17.6256 7.95794 18.2292 9.41507 18.2292 10.9344V13.5384C18.2292 14.2291 18.5036 14.8914 18.992 15.3797C19.4803 15.8681 20.1427 16.1424 20.8334 16.1424Z" fill="#D45A23" />
                        <path d="M14.8073 19.1575C14.8902 19.047 14.9258 18.9081 14.9062 18.7714C14.8867 18.6346 14.8136 18.5113 14.7031 18.4284C14.5926 18.3455 14.4537 18.3099 14.317 18.3295C14.1802 18.349 14.0568 18.422 13.974 18.5325C12.7177 20.2195 10.9989 21.5058 9.02605 22.2354C8.90455 22.2878 8.80754 22.3844 8.75471 22.5057C8.70188 22.627 8.6972 22.7639 8.74162 22.8885C8.78604 23.0131 8.87622 23.1162 8.99386 23.1767C9.11149 23.2373 9.24777 23.2508 9.37501 23.2145C11.5399 22.4156 13.4267 21.0064 14.8073 19.1575Z" fill="#D45A23" />
                        <path d="M15.474 20.0008C14.8643 20.7875 14.1652 21.5006 13.3906 22.1257C13.2979 22.2181 13.2434 22.342 13.2379 22.4729C13.2325 22.6037 13.2765 22.7317 13.3612 22.8316C13.4459 22.9314 13.5651 22.9956 13.6951 23.0115C13.8251 23.0274 13.9562 22.9938 14.0625 22.9173C14.9015 22.2409 15.66 21.4702 16.3229 20.6206C16.4051 20.508 16.4392 20.3674 16.4177 20.2297C16.3963 20.092 16.3209 19.9684 16.2084 19.8862C16.0958 19.8041 15.9552 19.77 15.8174 19.7914C15.6797 19.8129 15.5562 19.8882 15.474 20.0008Z" fill="#D45A23" />
                        <path d="M15.1041 11.9815V10.9399C15.1041 10.2493 14.8298 9.58697 14.3414 9.09863C13.853 8.61029 13.1906 8.33594 12.4999 8.33594C11.8093 8.33594 11.1469 8.61029 10.6585 9.09863C10.1701 9.58697 9.89578 10.2493 9.89578 10.9399V11.9815C9.89578 13.2246 9.40192 14.4168 8.52285 15.2959C7.64377 16.1749 6.45148 16.6687 5.20828 16.6687H4.16662C4.02848 16.6687 3.89601 16.7236 3.79833 16.8212C3.70066 16.9189 3.64578 17.0514 3.64578 17.1895C3.64578 17.3276 3.70066 17.4601 3.79833 17.5578C3.89601 17.6554 4.02848 17.7103 4.16662 17.7103H5.20828C6.72775 17.7103 8.18499 17.1067 9.25942 16.0324C10.3338 14.958 10.9374 13.5009 10.9374 11.9815V10.9399C10.9374 10.5256 11.1021 10.1282 11.3951 9.83515C11.6881 9.54214 12.0855 9.37753 12.4999 9.37753C12.9144 9.37753 13.3118 9.54214 13.6048 9.83515C13.8978 10.1282 14.0625 10.5256 14.0625 10.9399V11.9815C14.063 14.1605 13.2599 16.2631 11.807 17.887C10.354 19.5109 8.3532 20.5421 6.18745 20.783C6.04932 20.7982 5.92288 20.8677 5.83594 20.9761C5.74901 21.0845 5.70871 21.223 5.72391 21.3611C5.7391 21.4992 5.80855 21.6257 5.91697 21.7126C6.02539 21.7995 6.1639 21.8398 6.30203 21.8246C8.72373 21.5553 10.9609 20.4021 12.5851 18.5858C14.2093 16.7696 15.1062 14.418 15.1041 11.9815Z" fill="#D45A23" />
                        <path d="M13.0208 11.9765V10.9349C13.0208 10.7967 12.9659 10.6643 12.8682 10.5666C12.7706 10.4689 12.6381 10.4141 12.4999 10.4141C12.3618 10.4141 12.2293 10.4689 12.1317 10.5666C12.034 10.6643 11.9791 10.7967 11.9791 10.9349V11.9765C11.9791 13.7721 11.2658 15.4941 9.99598 16.7638C8.72621 18.0335 7.00402 18.7468 5.20828 18.7468H4.16662C4.02848 18.7468 3.89601 18.8017 3.79833 18.8994C3.70066 18.997 3.64578 19.1295 3.64578 19.2676C3.64578 19.4058 3.70066 19.5382 3.79833 19.6359C3.89601 19.7336 4.02848 19.7884 4.16662 19.7884H5.20828C6.23423 19.7884 7.25014 19.5864 8.198 19.1938C9.14585 18.8012 10.0071 18.2258 10.7326 17.5004C11.458 16.7749 12.0335 15.9138 12.4261 14.966C12.8187 14.0182 13.0208 13.0023 13.0208 11.9765Z" fill="#D45A23" />
                    </svg>

                </span>
                <span className="text-orange-700 text-sm">"Enjoy fast, secure transactions with just a touch — effortless payments at your fingertips!"</span>
            </div>
            <div className="flex items-center justify-center mt-6">
                <div className="flex items-center">
                    {[1, 2, 3].map((s, index) => (
                        <React.Fragment key={index}>
                            <div className="flex flex-col items-center">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${step > s ? 'bg-green-500' : 'bg-white border-2 border-green-500'}`}>
                                    {step > s ? <span className="text-white font-bold">✔</span> : <div className="w-3 h-3 rounded-full bg-green-500"></div>}
                                </div>
                            </div>
                            {index < 2 && <div className="w-12 h-1 bg-gray-300"></div>}
                        </React.Fragment>
                    ))}
                </div>
            </div>

            {step === 1 && (
                <>
                    <p className="text-lg font-semibold text-gray-800 mt-8">Remitter Details</p>
                    <div className="mt-4 w-full max-w-sm">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="mobileNumber">
                            Mobile Number
                        </label>
                        <div className="relative">
                            <input
                                id="mobileNumber"
                                type="tel"
                                className={`w-full px-3 py-2 border ${mobileValidation.isTouched && !mobileValidation.isValid ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 ${mobileValidation.isTouched && !mobileValidation.isValid ? 'focus:ring-red-500' : 'focus:ring-blue-500'}`}
                                placeholder="Enter mobile number"
                                value={mobileNumber}
                                onChange={handleMobileNumberChange}
                                onBlur={handleMobileNumberBlur}
                                maxLength={10}
                                disabled={isLoading || showOtpFields}
                            />
                            {mobileValidation.isTouched && mobileValidation.isValid && mobileNumber.length === 10 && (
                                <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-green-500">
                                    <FaCheckCircle />
                                </span>
                            )}
                        </div>
                        {mobileValidation.isTouched && !mobileValidation.isValid && (
                            <p className="text-red-500 text-sm mt-1">{mobileValidation.errorMessage}</p>
                        )}
                        {errorMessage && !mobileValidation.errorMessage && (
                            <p className="text-red-500 text-sm mt-1">{errorMessage}</p>
                        )}
                        <div className="mt-2 text-xs text-gray-500">
                            <p>• Mobile number must be 10 digits</p>
                            <p>• Should start with 6, 7, 8, or 9</p>
                            <p>• No special characters or spaces allowed</p>
                        </div>
                    </div>

                    {showOtpFields && (
                        <div className="mt-4 flex flex-col items-center w-full max-w-sm">
                            {isAadharVerified ? (
                                <p className="text-lg font-semibold text-gray-800 text-center">
                                    Remitter Name: {remitterName || "Loading..."}
                                </p>
                            ) : (
                                <p className="text-lg font-semibold text-gray-800 text-center">
                                    Remitter Name: <span className="text-red-500">Not Aadhar Verified</span>
                                </p>
                            )}
                            <p className="text-sm text-gray-600 text-center">OTP sent to your mobile: {mobileNumber}</p>
                            <div className="flex justify-center space-x-2 mt-2">
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        ref={(el) => (otpInputs.current[index] = el)}
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        maxLength="1"
                                        className="w-10 h-10 text-center text-lg border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={digit}
                                        onChange={(e) => handleOtpChange(index, e.target.value)}
                                        onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                        autoComplete="one-time-code"
                                    />
                                ))}
                            </div>
                            <button
                                className="mt-4 text-sm text-blue-600 hover:underline text-center"
                                onClick={handleResendOtp}
                                disabled={isLoading}
                            >
                                {isLoading ? "Sending..." : "Resend OTP"}
                            </button>
                        </div>
                    )}

                    <button
                        className={`mt-6 px-6 py-2 ${isLoading ? 'bg-gray-400' : 'bg-green-500 hover:bg-green-600'} text-white font-bold rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500`}
                        onClick={handleProceed}
                        disabled={isLoading}
                    >
                        {isLoading ? "Processing..." : "Proceed"}
                    </button>
                </>
            )}

            {step === 2 && (
                <div className="mt-6 w-full max-w-sm">
                    <p className="text-lg font-semibold text-gray-800">Biometric Verification</p>
                    <p className="text-sm text-gray-600 mb-4">Please provide your biometric details to proceed.</p>
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="aadhaarNumber">
                            Aadhaar Number
                        </label>
                        <input
                            id="aadhaarNumber"
                            type="text"
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter Aadhaar Number"
                            value={aadhaarNumber}
                            onChange={handleAadhaarNumberChange}
                            maxLength={12}
                        />
                        {errorMessage && (
                            <p className="text-red-500 text-sm mt-1">{errorMessage}</p>
                        )}
                    </div>
                    <div className="flex items-center mb-4 text-green-600">
                        <p className="text-sm"><strong>Consent Status:</strong> {consentAccepted ? "Accepted ✓" : "Not Accepted"}</p>
                    </div>
                    <div className="mb-4">
                        <Biometric
                            setPidData={setPidData}
                            onVerificationComplete={handleBiometricVerification}
                        />
                    </div>
                    <button
                        onClick={performEkyc}
                        className={`w-full px-6 py-2 ${isLoading ? 'bg-gray-400' : 'bg-green-500 hover:bg-green-600'} text-white font-bold rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500`}
                        disabled={isLoading}
                    >
                        {isLoading ? "Processing..." : "Verify"}
                    </button>
                </div>
            )}

            {step === 3 && (
                <div className="mt-6 w-full max-w-sm">
                    <p className="text-lg font-semibold text-gray-800">PAN Verification</p>
                    <p className="text-sm text-gray-600 mb-4">Please enter your PAN details for verification.</p>
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="panNumber">
                            PAN Number
                        </label>
                        <input
                            id="panNumber"
                            type="text"
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter PAN Number (e.g., ABCDE1234F)"
                            value={panNumber}
                            onChange={handlePanNumberChange}
                            maxLength={10}
                        />
                        {errorMessage && (
                            <p className="text-red-500 text-sm mt-1">{errorMessage}</p>
                        )}
                    </div>
                    {isPanVerified && (
                        <div className="mb-4 p-2 bg-green-100 text-green-700 rounded-md flex items-center">
                            <FaCheckCircle className="mr-2" />
                            <span>PAN verification successful!</span>
                        </div>
                    )}
                    <button
                        onClick={handleProceed}
                        className={`w-full px-6 py-2 ${isLoading ? 'bg-gray-400' : 'bg-green-500 hover:bg-green-600'} text-white font-bold rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500`}
                        disabled={isLoading}
                    >
                        {isLoading ? "Processing..." : (isPanVerified ? "Continue" : "Verify")}
                    </button>
                </div>
            )}


            {showConsentPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                        <h2 className="text-xl font-bold mb-4">Consent for Biometric Verification</h2>

                        {consentLanguages.length > 0 && (
                            <div className="mb-4">
                                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="consentLanguage">
                                    Select Language
                                </label>
                                <select
                                    id="consentLanguage"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    value={selectedConsentLang}
                                    onChange={handleConsentLanguageChange}
                                >
                                    {consentLanguages.map(lang => (
                                        <option
                                            key={lang.language_code || lang.id}
                                            value={lang.language_code || lang.id}
                                        >
                                            {lang.language_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        <div className="mb-4 max-h-60 overflow-y-auto border border-gray-300 rounded-lg p-3">
                            {consentText ? (
                                <p className="text-gray-700 whitespace-pre-line">{consentText}</p>
                            ) : (
                                <div>
                                    <p className="text-gray-500 italic">Fetching consent text...</p>
                                    <p className="text-xs text-gray-400 mt-2">
                                        Note: The complete consent text will be displayed after selecting "I Agree"
                                    </p>
                                </div>
                            )}
                        </div>

                        {errorMessage && (
                            <p className="text-red-500 text-sm mb-4">{errorMessage}</p>
                        )}

                        <div className="flex justify-between">
                            <button
                                className="px-4 py-2 bg-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400"
                                onClick={() => {
                                    setConsentAccepted(false);
                                    setShowConsentPopup(false);
                                }}
                                disabled={isLoading}
                            >
                                Decline
                            </button>
                            <button
                                className={`px-4 py-2 ${isLoading ? 'bg-gray-400' : 'bg-green-500 hover:bg-green-600'} text-white font-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500`}
                                onClick={validateConsent}
                                disabled={isLoading}
                            >
                                {isLoading ? "Processing..." : "I Agree"}
                            </button>
                        </div>

                    </div>
                </div>
            )}

            {showPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg text-center w-80">
                        <FaCheckCircle className="text-green-500 text-5xl mx-auto mb-4" />
                        <h2 className="text-xl font-bold mb-2">Verification Successful</h2>
                        <p className="text-gray-600 mb-4">Biometric verification completed successfully.</p>
                        <button
                            className="px-6 py-2 bg-green-500 text-white font-bold rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
                            onClick={handleClosePopup}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            )}

            {showOtpVerificationPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg text-center w-80">
                        {otpVerificationStatus.success ? (
                            <FaCheckCircle className="text-green-500 text-5xl mx-auto mb-4" />
                        ) : (
                            <FaTimesCircle className="text-red-500 text-5xl mx-auto mb-4" />
                        )}
                        <h2 className="text-xl font-bold mb-2">
                            {otpVerificationStatus.success ? "Success" : "Verification Failed"}
                        </h2>
                        <p className="text-gray-600 mb-4">{otpVerificationStatus.message}</p>
                        <button
                            className={`px-6 py-2 ${otpVerificationStatus.success ? 'bg-green-500 hover:bg-green-600' : 'bg-blue-500 hover:bg-blue-600'} text-white font-bold rounded-lg focus:outline-none focus:ring-2 focus:ring-${otpVerificationStatus.success ? 'green' : 'blue'}-500`}
                            onClick={handleCloseOtpVerificationPopup}
                        >
                            {otpVerificationStatus.success ? "Continue" : "Try Again"}
                        </button>
                    </div>
                </div>
            )}

            {showPanVerificationPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg text-center w-80">
                        {panVerificationStatus.success ? (
                            <FaCheckCircle className="text-green-500 text-5xl mx-auto mb-4" />
                        ) : (
                            <FaTimesCircle className="text-red-500 text-5xl mx-auto mb-4" />
                        )}
                        <h2 className="text-xl font-bold mb-2">
                            {panVerificationStatus.success ? "Verification Successful" : "Verification Failed"}
                        </h2>
                        <p className="text-gray-600 mb-4">{panVerificationStatus.message}</p>
                        <button
                            className={`px-6 py-2 ${panVerificationStatus.success ? 'bg-green-500 hover:bg-green-600' : 'bg-blue-500 hover:bg-blue-600'} text-white font-bold rounded-lg focus:outline-none focus:ring-2 focus:ring-${panVerificationStatus.success ? 'green' : 'blue'}-500`}
                            onClick={handleClosePanVerificationPopup}
                        >
                            {panVerificationStatus.success ? "Continue" : "Try Again"}
                        </button>
                    </div>
                </div>
            )}

            {showOtpMessagePopup && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg text-center w-80">
                        <div className="bg-blue-100 p-3 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <h2 className="text-xl font-bold mb-2">OTP Status</h2>
                        <p className="text-gray-600 mb-4">{otpMessage}</p>
                        <button
                            className="px-6 py-2 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onClick={handleCloseOtpMessagePopup}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PpiTransfer;